//@ts-check
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */
/**
 * @module PurchaseOrders
 */
/**
 *
 * @param {Object} props
 * @param {string} props.id
 */

const useFetchPurchaseOrderLines = ({ id }) => {
  const [response, setResponse] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    axios
      .get(`/efactura/purchaseorder/${id}/`)
      .then((request_response) => {
        setResponse(request_response.data)
      })
      .finally(() => setLoading(false))
  }, [id])

  useEffect(() => {
    if (id && !loading) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return { response, loading, reFetch: fetchData }
}

export default useFetchPurchaseOrderLines
